import React, {
  useState, useCallback, useEffect, useContext,
} from 'react';
import { InputLabel } from '@material-ui/core';
import { useField, useFormikContext } from 'formik';

import MultiEmailComponent from './MultiEmailComponent';
import { useId } from '../../hooks';
import { ItemFormContext } from '..';

type Props = {
  name: string;
  label?: string;
  disabled?: boolean;
  autoFocus?: boolean;
};

/* eslint-disable react-hooks/exhaustive-deps */

const MultiEmailField = ({
  name, label = 'Emails', disabled = false, autoFocus = false,
}: Props) => {
  const inputId = useId();
  const [emails, setEmails] = useState<string[]>([]);
  const [inputValue, setInputValue] = useState('');
  const { setFieldValue } = useFormikContext();
  const [field] = useField({ name });
  const { setDisableSubmit, disableSubmit } = useContext(ItemFormContext);

  useEffect(() => {
    if (!disableSubmit && inputValue) {
      setDisableSubmit(true);
    } else if (disableSubmit && !inputValue) {
      setDisableSubmit(false);
    }
  }, [disableSubmit, setDisableSubmit, inputValue]);

  const onChange = useCallback((value: string[]) => {
    setEmails(value);
    const stringEmails = value.join(',');
    setFieldValue(name as never, stringEmails);
  }, [name, setEmails, setFieldValue]);

  // @ts-ignore
  return (
    <>
      <InputLabel
        htmlFor={inputId}
        style={{ fontSize: 12 }}
      >
        {label}
      </InputLabel>
      <div id={inputId}>
        <MultiEmailComponent
          disabled={disabled}
          autoFocus={autoFocus}
          emails={emails}
          onChange={onChange}
          onChangeInput={setInputValue}
          getLabel={(
            email: string,
            index: number,
            removeEmail: (index: number) => void,
          ) => (
            <div data-tag key={index}>
              <div data-tag-item>
                {email}
              </div>
              <span
                data-tag-handle
                onClick={() => removeEmail(index)}
              >
                ×
              </span>
            </div>
          )}
        />
        <input type="hidden" {...field} />
      </div>
    </>
  );
};

export default MultiEmailField;
